(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recipes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-recipes .swiper').forEach(function (el) {
      var outer = el.closest('.swiper-outer');
      new Swiper(el, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        breakpoints: {
          550:  { slidesPerView: 1.5 },
          700:  { slidesPerView: 2.1 },

          1024: { 
            slidesPerView: 3,
            navigation: {
              prevEl: outer.querySelector('.swiper-btn-prev'),
              nextEl: outer.querySelector('.swiper-btn-next'),
            }
          }
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-article .keep-reading .swiper').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1.4,
        spaceBetween: 20,
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-blog-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-blog-grid').forEach(function (section) {
      const filterSelect = section.querySelector('[data-filter-select]');
      const grid = section.querySelector('.articles-grid');
      const paginationWrapper = section.querySelector('[data-pagination-wrapper]');

      if (filterSelect) {
        filterSelect.addEventListener('change', function () {
          window.location.href = filterSelect.value;
        });
      }

      function bindLoadMore() {
        const loadMore = section.querySelector('[data-load-more]');
        if (!loadMore || !grid || !paginationWrapper) return;

        loadMore.addEventListener('click', function (event) {
          event.preventDefault();
          if (loadMore.dataset.loading === 'true') return;

          const nextUrl = loadMore.getAttribute('href');
          if (!nextUrl) return;

          loadMore.dataset.loading = 'true';
          loadMore.textContent = 'LOADING...';
          loadMore.style.pointerEvents = 'none';

          fetch(nextUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const nextSection = doc.querySelector('.ps-blog-grid[data-section-id="{{ section.id }}"]') || doc.querySelector('.ps-blog-grid');
              if (!nextSection) return;

              const newCards = nextSection.querySelectorAll('.articles-grid .article-card');
              newCards.forEach(function (card) {
                grid.appendChild(card);
              });

              const nextLoadMore = nextSection.querySelector('[data-load-more]');
              if (nextLoadMore) {
                loadMore.setAttribute('href', nextLoadMore.getAttribute('href'));
                loadMore.textContent = 'LOAD MORE';
                loadMore.style.pointerEvents = '';
                loadMore.dataset.loading = 'false';
              } else {
                paginationWrapper.remove();
              }
            })
            .catch(function () {
              loadMore.textContent = 'LOAD MORE';
              loadMore.style.pointerEvents = '';
              loadMore.dataset.loading = 'false';
            });
        });
      }

      bindLoadMore();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-collection-grid"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.ps-collection-grid').forEach(function (section) {
				const filterDrawer = section.querySelector('[data-ps-filter-drawer]');
				const openFilterButton = section.querySelector('[data-ps-filter-open]');
				const closeFilterButton = section.querySelector('[data-ps-filter-close]');
				const applyFilterButton = section.querySelector('[data-ps-filter-apply]');
				const mobileSortSelect = section.querySelector('[data-ps-mobile-sort]');

				function closeDrawer() {
					if (!filterDrawer) return;
					filterDrawer.classList.remove('is-open');
					filterDrawer.setAttribute('aria-hidden', 'true');
					document.body.style.overflow = '';
				}

				function openDrawer() {
					if (!filterDrawer) return;
					filterDrawer.classList.add('is-open');
					filterDrawer.setAttribute('aria-hidden', 'false');
					document.body.style.overflow = 'hidden';
				}

				if (openFilterButton) {
					openFilterButton.addEventListener('click', openDrawer);
				}

				if (closeFilterButton) {
					closeFilterButton.addEventListener('click', closeDrawer);
				}

				if (filterDrawer) {
					filterDrawer.addEventListener('click', function (event) {
						if (event.target === filterDrawer) {
							closeDrawer();
						}
					});
				}

				if (applyFilterButton) {
					applyFilterButton.addEventListener('click', function () {
						const url = new URL(window.location.href);
						if (mobileSortSelect && mobileSortSelect.value) {
							url.searchParams.set('sort_by', mobileSortSelect.value);
						}
						window.location.href = url.toString();
					});
				}

				document.addEventListener('keydown', function (event) {
					if (event.key === 'Escape') {
						closeDrawer();
					}
				});

			section.querySelectorAll('[data-ps-variant-select]').forEach(function (variantSelect) {
				variantSelect.addEventListener('change', function () {
					const card = variantSelect.closest('.ps-product-card');
					if (!card) return;

					const selected = variantSelect.options[variantSelect.selectedIndex];
					const addButton = card.querySelector('[data-ps-add-to-cart]');
					const image = card.querySelector('.product-image img');
					const priceEl = card.querySelector('.product-price');
					const compareEl = card.querySelector('.product-compare-price');

					if (addButton) {
						addButton.dataset.variantId = selected.value;
						const isAvailable = selected.dataset.available === 'true';
						addButton.disabled = !isAvailable;
						addButton.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
					}

					if (image && selected.dataset.image) {
						image.src = selected.dataset.image;
					}

					if (priceEl && selected.dataset.price) {
						priceEl.textContent = selected.dataset.price;
					}

					if (selected.dataset.comparePrice) {
						if (compareEl) {
							compareEl.textContent = selected.dataset.comparePrice;
							compareEl.style.display = '';
						} else if (priceEl) {
							const newCompare = document.createElement('p');
							newCompare.className = 'product-compare-price';
							newCompare.textContent = selected.dataset.comparePrice;
							priceEl.insertAdjacentElement('afterend', newCompare);
						}
					} else if (compareEl) {
						compareEl.style.display = 'none';
					}
				});
			});

			section.querySelectorAll('[data-ps-add-to-cart]').forEach(function (button) {
				button.addEventListener('click', function () {
					const variantId = button.dataset.variantId;
					const originalText = button.textContent;

					if (!variantId || button.disabled) return;

					button.disabled = true;
					button.textContent = 'Adding...';

					fetch('/cart/add.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({ id: variantId, quantity: 1 }),
					})
						.then(function (response) {
							if (!response.ok) throw new Error('Add to cart failed');
							return fetch('/cart.js').then(function (cartResponse) {
								return cartResponse.json();
							});
						})
						.then(function (cart) {
							button.textContent = 'Added!';

							document.dispatchEvent(
								new CustomEvent('cart:update', {
									bubbles: true,
									detail: {
										resource: cart,
										sourceId: button.id || null,
										data: {
											itemCount: cart.item_count,
											variantId: variantId,
											source: 'ps-collection-grid',
										},
									},
								})
							);

							const cartDrawer = document.querySelector('cart-drawer');
							if (cartDrawer) {
								cartDrawer.open();
							}

							if (window.Rebuy && window.Rebuy.SmartCart) {
								window.Rebuy.SmartCart.refresh();
								window.Rebuy.SmartCart.show();
							}

							setTimeout(function () {
								button.textContent = originalText;
								button.disabled = false;
							}, 1500);
						})
						.catch(function () {
							setTimeout(function () {
								button.textContent = originalText;
								button.disabled = false;
							}, 1800);
						});
				});
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-difference"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-difference .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1.25,
        spaceBetween: 10,
        breakpoints: {
          475: { slidesPerView: 1.65 }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-dropdowns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-dropdowns').forEach(function(section) {
      section.querySelectorAll('.dropdown-toggle').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var dropdown = btn.closest('.dropdown');
          var isOpen = dropdown.classList.contains('open');

          section.querySelectorAll('.dropdown.open').forEach(function(openDrop) {
            if (openDrop !== dropdown) openDrop.classList.remove('open');
          });

          dropdown.classList.toggle('open', !isOpen);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.ps-faqs');
    if (!section) return;

    var mobileSelect = section.querySelector('.faq-mobile-select');
    if (mobileSelect) {
      mobileSelect.addEventListener('change', function() {
        var target = document.getElementById(mobileSelect.value);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    section.querySelectorAll('.faq-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dropdown = btn.closest('.faq-dropdown');
        var isOpen = dropdown.classList.contains('open');

        dropdown.closest('.faq-group').querySelectorAll('.faq-dropdown.open').forEach(function(openDrop) {
          if (openDrop !== dropdown) openDrop.classList.remove('open');
        });

        dropdown.classList.toggle('open', !isOpen);
      });
    });

    var filters = section.querySelectorAll('.filter');

    filters.forEach(function(filter) {
      filter.addEventListener('click', function() {
        filters.forEach(function(f) { f.classList.remove('active'); });
        filter.classList.add('active');
      });
    });

    var faqGroups = section.querySelectorAll('.faq-group');
    if ('IntersectionObserver' in window && faqGroups.length) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            filters.forEach(function(f) {
              f.classList.toggle('active', f.getAttribute('href') === '#' + id);
            });
          }
        });
      }, { rootMargin: '-120px 0px -50% 0px', threshold: 0 });

      faqGroups.forEach(function(group) { observer.observe(group); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-global-recipes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-global-recipes .swiper').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-history"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-history').forEach(function(section) {
      const el = section.querySelector('.swiper');

      new Swiper(el, {
        slidesPerView: 1.35,
        spaceBetween: 20,
        navigation: {
          prevEl: section.querySelector('.swiper-btn-prev'),
          nextEl: section.querySelector('.swiper-btn-next'),
        },
        breakpoints: {
          600:  { slidesPerView: 1.85 },
          800:  { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1400: { slidesPerView: 3, spaceBetween: 25 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-home-collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-home-collection-slider').forEach(function(section) {

      const swipers = [];

      section.querySelectorAll('.product-set').forEach(function(set) {
        const swiper = new Swiper(set.querySelector('.swiper'), {
          slidesPerView: 1.15,
          spaceBetween: 10,
          breakpoints: {
            450:  { slidesPerView: 1.3 },
            600:  { slidesPerView: 2.15 },
            800: { slidesPerView: 3.15 },
            1000: { slidesPerView: 4.15 },
            1200: { slidesPerView: 5, spaceBetween: 15 },
          },
        });
        swipers.push(swiper);
      });

      function switchTo(index) {
        section.querySelectorAll('.product-set').forEach(function(set, i) {
          if (i === index) {
            set.classList.remove('hidden');
            swipers[i].update();
          } else {
            set.classList.add('hidden');
          }
        });
      }

      section.querySelectorAll('.filter-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          section.querySelectorAll('.filter-btn').forEach(function(b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');
          switchTo(parseInt(btn.dataset.index));
        });
      });

      const select = section.querySelector('.collection-select');
      if (select) {
        function updateSelectColor() {
          const color = select.options[select.selectedIndex].dataset.color;
          if (color) select.style.setProperty('--block-color', color);
        }
        updateSelectColor();
        select.addEventListener('change', function() {
          updateSelectColor();
          switchTo(parseInt(select.value));
        });
      }

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          // Update add to cart variant
          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          // Update product image
          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          // Update prices
          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              // Horizon: dispatch cart:update with itemCount so cart drawer + bubble update
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-collection-slider',
                  },
                },
              }));

              // Horizon: open cart drawer
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.open();
              }

              // Rebuy SmartCart: refresh + open
              if (window.Rebuy?.SmartCart) {
                window.Rebuy.SmartCart.refresh();
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-home-hero .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        autoHeight: true, 
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-comparison"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.ps-product-comparison .swiper', {
    slidesPerView: 1.05,
    spaceBetween: 15,
    breakpoints: {
      500: {
        slidesPerView: 1.35,
      },
      650: {
        slidesPerView: 2.05
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-faqs .faq-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dropdown = btn.closest('.faq-dropdown');
        var isOpen = dropdown.classList.contains('open');

        document.querySelectorAll('.ps-product-faqs .faq-dropdown.open').forEach(function(openDrop) {
          if (openDrop !== dropdown) openDrop.classList.remove('open');
        });

        dropdown.classList.toggle('open', !isOpen);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.ps-product-main');
    if (!section) return;

    // ── Lightbox ──
    var lightbox    = document.getElementById('ps-lightbox');
    var lightboxImg = document.getElementById('ps-lightbox-img');
    var counter     = document.getElementById('ps-lightbox-counter');
    var closeBtn    = document.getElementById('ps-lightbox-close');
    var prevBtn     = document.getElementById('ps-lightbox-prev');
    var nextBtn     = document.getElementById('ps-lightbox-next');

    if (!lightbox) return;

    var imageItems = Array.from(section.querySelectorAll('.image-item'));
    var lbImages = imageItems.map(function (item) {
      return {
        src: item.dataset.fullSrc || item.querySelector('img').src,
        alt: item.querySelector('img').alt
      };
    });

    var current = 0;

    function open(index) {
      current = index;
      render();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      lightbox.focus();
    }

    function close() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    function render() {
      lightboxImg.src = lbImages[current].src;
      lightboxImg.alt = lbImages[current].alt;
      counter.textContent = (current + 1) + ' / ' + lbImages.length;
      prevBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
      nextBtn.style.visibility = current === lbImages.length - 1 ? 'hidden' : 'visible';
    }

    function prev() { if (current > 0) { current--; render(); } }
    function next() { if (current < lbImages.length - 1) { current++; render(); } }

    imageItems.forEach(function (item, i) {
      item.addEventListener('click', function () { open(i); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); }
      });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape')      close();
      if (e.key === 'ArrowLeft')   prev();
      if (e.key === 'ArrowRight')  next();
    });

    // ── Variant Selector ──
    var form = section.querySelector('.product-form');
    if (!form) return;

    var variantsEl = form.querySelector('.product-variants-json');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var variantIdInput = form.querySelector('.variant-id-input');
    var atcBtn = form.querySelector('.atc-btn');

    // In BIS mode (out-of-stock variant) the ATC button opens the Back-in-Stock
    // modal instead of submitting the cart form. Works for the static OOS render
    // too, since the button ships with .atc-btn--bis from Liquid.
    atcBtn.addEventListener('click', function (e) {
      if (atcBtn.classList.contains('atc-btn--bis')) {
        e.preventDefault();
        if (window.PSBackInStock) window.PSBackInStock.open(variantIdInput.value);
      }
    });

    var selectedOptions = [];

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      }) || null;
    }

    function applyVariant(variant) {
      if (!variant) return;
      selectedOptions = variant.options.slice();
      form.querySelectorAll('.variant-option').forEach(function (optionEl) {
        var idx = parseInt(optionEl.dataset.optionIndex, 10);
        var val = variant.options[idx];
        optionEl.querySelectorAll('.pill').forEach(function (p) {
          p.classList.toggle('active', p.dataset.value === val);
        });
        var labelSpan = optionEl.querySelector('.selected-value');
        if (labelSpan) labelSpan.textContent = val.toUpperCase();
      });
    }

    // Determine initial variant: URL param → first available → first overall
    var urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    var initialVariant =
      (urlVariantId && variants.find(function (v) { return v.id === urlVariantId; })) ||
      variants.find(function (v) { return v.available; }) ||
      variants[0];

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    var priceEl   = section.querySelector('.prices-wrapper .price');
    var compareEl = section.querySelector('.prices-wrapper .compare-at-price');

    function updateUI(variant, skipHistory) {
      // Keep the hidden id and URL param in sync with the resolved variant. On a
      // null variant (selected option combo matches no variant) we CLEAR them, so
      // no consumer — cart submit, Enter-key submit, sticky bar, BIS modal — can
      // act on the previously selected variant.
      variantIdInput.value = variant ? variant.id : '';
      if (!skipHistory) {
        var url = new URL(window.location.href);
        if (variant) {
          url.searchParams.set('variant', variant.id);
        } else {
          url.searchParams.delete('variant');
        }
        history.replaceState({}, '', url.toString());
      }

      // Three states:
      //  - in stock          → live Add to Cart (submit)
      //  - out of stock       → Back-in-Stock trigger for THIS variant (type=button);
      //                         the click handler opens the Klaviyo BIS modal.
      //  - no matching variant → disable. variantIdInput.value still holds the previous
      //                         variant (the guard above only updates it when `variant`
      //                         is truthy), so entering BIS mode here would subscribe the
      //                         customer to the WRONG variant. Stay out of BIS mode.
      if (variant && variant.available) {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
        atcBtn.type = 'submit';
        atcBtn.classList.remove('atc-btn--bis');
      } else if (variant) {
        atcBtn.textContent = 'Notify me when back in stock';
        atcBtn.disabled = false;
        atcBtn.type = 'button';
        atcBtn.classList.add('atc-btn--bis');
      } else {
        atcBtn.textContent = 'Unavailable';
        atcBtn.disabled = true;
        atcBtn.type = 'button';
        atcBtn.classList.remove('atc-btn--bis');
      }

      if (variant && priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      }

      if (variant && variant.featured_image) {
        var firstItem = section.querySelector('.image-item.image-full') || section.querySelector('.image-item');
        if (firstItem) {
          var img = firstItem.querySelector('img');
          if (img) img.src = variant.featured_image.src;
          firstItem.dataset.fullSrc = variant.featured_image.src;
          // keep lightbox in sync
          if (lbImages[0]) lbImages[0].src = variant.featured_image.src;
        }
      }
    }

    applyVariant(initialVariant);
    updateUI(initialVariant, !!urlVariantId);

    form.querySelectorAll('.pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var optionIndex = parseInt(pill.dataset.optionIndex, 10);
        var value = pill.dataset.value;

        selectedOptions[optionIndex] = value;

        var optionEl = form.querySelector('.variant-option[data-option-index="' + optionIndex + '"]');
        optionEl.querySelectorAll('.pill').forEach(function (p) {
          p.classList.toggle('active', p.dataset.value === value);
        });

        var labelSpan = optionEl.querySelector('.selected-value');
        if (labelSpan) labelSpan.textContent = value.toUpperCase();

        updateUI(findVariant());
      });
    });

    // ── Shop Pay modal ──
    var shoppayLearn = section.querySelector('.shoppay-learn');
    if (shoppayLearn) {
      var spCloseListenersAdded = false;

      function getSpRoot() {
        var provider = document.querySelector('[data-nametag="shop-portal-provider"]');
        return provider && provider.shadowRoot;
      }

      function closeShopPayModal() {
        var root = getSpRoot();
        if (!root) return;
        var container = root.querySelector('[data-testid="authorize-modal-container"]');
        var overlay   = root.querySelector('[data-testid="authorize-modal-overlay"]');
        var modal     = root.querySelector('[data-testid="authorize-modal"]');
        if (container) {
          container.classList.add('invisible', 'pointer-events-none');
          container.classList.remove('pointer-events-auto');
        }
        if (overlay) {
          overlay.classList.add('opacity-0');
          overlay.setAttribute('aria-hidden', 'true');
        }
        if (modal) {
          modal.classList.add('opacity-0', 'sm_translate-y-full');
          modal.setAttribute('data-visible', 'false');
          modal.setAttribute('aria-hidden', 'true');
        }
      }

      shoppayLearn.addEventListener('click', function () {
        var root = getSpRoot();
        if (!root) return;
        var container = root.querySelector('[data-testid="authorize-modal-container"]');
        var overlay   = root.querySelector('[data-testid="authorize-modal-overlay"]');
        var modal     = root.querySelector('[data-testid="authorize-modal"]');
        if (container) {
          container.classList.remove('invisible', 'pointer-events-none');
          container.classList.add('pointer-events-auto');
        }
        if (overlay) {
          overlay.classList.remove('opacity-0');
          overlay.setAttribute('aria-hidden', 'false');
        }
        if (modal) {
          modal.classList.remove('opacity-0', 'sm_translate-y-full');
          modal.setAttribute('data-visible', 'true');
          modal.setAttribute('aria-hidden', 'false');
        }
        if (!spCloseListenersAdded) {
          var closeBtn = root.querySelector('[data-testid="authorize-modal-close-button"]');
          if (closeBtn) closeBtn.addEventListener('click', closeShopPayModal);
          if (overlay)  overlay.addEventListener('click', closeShopPayModal);
          spCloseListenersAdded = true;
        }
      });
    }

    // ── Mobile gallery Swiper ──
    var mobileGalleryEl = section.querySelector('.mobile-gallery');
    if (mobileGalleryEl && typeof Swiper !== 'undefined') {
      new Swiper(mobileGalleryEl, {
        slidesPerView: 1.15,
        spaceBetween: 10,
        breakpoints: {
          500: { slidesPerView: 1.85 },
        },
      });
    }

    // ── Add to Cart → open cart drawer ──
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = variantIdInput.value;
      if (!variantId) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      // Add selling_plan only for an actual subscription. The authoritative signal is
      // the StayAI purchaseType radio — NOT the plan <select> value: Safari / iOS WebKit
      // can restore the <select> from autofill/bfcache to a stale plan id even while
      // One-Time is selected, which would silently turn a one-time order into a
      // subscription. Gate on the radio, then read the plan id from the in-form select
      // (the native input[name="selling_plan"] lives in a sibling StayAI form).
      var payload = { id: variantId, quantity: 1 };
      var purchaseType = form.querySelector('input[name="purchaseType"]:checked');
      var isSubscription = !!(purchaseType && /subscription/i.test(purchaseType.value));
      var sellingPlanSelect = form.querySelector('select[name="stayai_selling_plan"]');
      if (isSubscription && sellingPlanSelect && sellingPlanSelect.value) {
        payload.selling_plan = sellingPlanSelect.value;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // Fire cart:update event so the drawer's cart count refreshes
        var cartEvent = new Event('cart:update', { bubbles: true });
        cartEvent.detail = { resource: data };
        document.dispatchEvent(cartEvent);

        // Open the drawer directly — works regardless of auto-open setting
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.showDialog === 'function') {
          drawer.showDialog();
        }

        // Restore button
        updateUI(findVariant());
      })
      .catch(function () {
        updateUI(findVariant());
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-manual"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-manual').forEach(function(section) {

      const set = section.querySelector('.product-set');
      if (!set) return;

      new Swiper(set.querySelector('.swiper'), {
        slidesPerView: 1.5,
        spaceBetween: 15,
        navigation: {
          prevEl: set.querySelector('.swiper-btn-prev'),
          nextEl: set.querySelector('.swiper-btn-next'),
        },
        breakpoints: {
          600:  { slidesPerView: 1.5 },
          768:  { slidesPerView: 2.5 },
          1025: { slidesPerView: 4, spaceBetween: 20 },
        },
      });

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-product-manual',
                  },
                },
              }));

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();

              if (window.Rebuy?.SmartCart) {
                window.Rebuy.SmartCart.refresh();
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-related"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-upsell').forEach(function(section) {

      const set = section.querySelector('.product-set');
      if (!set) return;

      new Swiper(set.querySelector('.swiper'), {
        slidesPerView: 1.35,
        spaceBetween: 10,
        breakpoints: {
          600:  { slidesPerView: 2.15 },
          800:  { slidesPerView: 3.15 },
          1000: { slidesPerView: 4.15 },
          1200: { slidesPerView: 5, spaceBetween: 15 },
        },
      });

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-product-upsell',
                  },
                },
              }));

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();

              if (window.Rebuy?.SmartCart) {
                window.Rebuy.SmartCart.refresh();
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-science-megablock"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-science-megablock').forEach(function(section) {

      // Experts swiper
      const expertsSwiper = new Swiper(section.querySelector('.experts-swiper'), {
        slidesPerView: 1.25,
        spaceBetween: 10,
        navigation: {
          prevEl: section.querySelector('.experts-btn-prev'),
          nextEl: section.querySelector('.experts-btn-next'),
        },
        breakpoints: {
          550: { slidesPerView: 2.15 },
          750: { slidesPerView: 3 },
          1000: { slidesPerView: 4, spaceBetween: 15 }
        },
      });

      // Video swiper
      const videoSwiper = new Swiper(section.querySelector('.video-swiper'), {
        slidesPerView: 1,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: section.querySelector('.video-btn-prev'),
          nextEl: section.querySelector('.video-btn-next'),
        },
      });

      // Stop playing video on slide change
      videoSwiper.on('slideChange', function() {
        section.querySelectorAll('.video-slide.is-playing').forEach(function(slide) {
          const v = slide.querySelector('video');
          if (v) { v.pause(); v.currentTime = 0; }
          slide.classList.remove('is-playing');
        });
      });

      // Play buttons
      section.querySelectorAll('.video-slide').forEach(function(slide) {
        const btn = slide.querySelector('.play-btn');
        const video = slide.querySelector('video');
        if (!btn || !video) return;

        btn.addEventListener('click', function() {
          section.querySelectorAll('.video-slide.is-playing').forEach(function(s) {
            const v = s.querySelector('video');
            if (v) { v.pause(); v.currentTime = 0; }
            s.classList.remove('is-playing');
          });
          slide.classList.add('is-playing');
          const v = slide.querySelector('video');
          if (v) v.play();
        });

        const videoEl = slide.querySelector('video');
        if (videoEl) videoEl.addEventListener('ended', function() {
          slide.classList.remove('is-playing');
        });
      });



    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-swiper-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-swiper-cards .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 2.15,
        spaceBetween: 20,
        breakpoints: {
          1025: { slidesPerView: 5, spaceBetween: 45 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-testimonial-slider').forEach(function(section) {
      const el = section.querySelector('.swiper');

      new Swiper(el, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        autoHeight: true,
        breakpoints: {
          500: {
            slidesPerView: 1.5,
          },
          650: {
            slidesPerView: 2.15,
          },
          900: {
            slidesPerView: 2.85,           
          },
          1024: {
            slidesPerView: 2.33,
            pagination: {
              el: section.querySelector('.swiper-pagination'),
              clickable: true,
            },
            navigation: {
              prevEl: section.querySelector('.swiper-btn-prev'),
              nextEl: section.querySelector('.swiper-btn-next'),
            },
          
          }
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-trusted-by"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-trusted-by').forEach(function(section) {
      const el = section.querySelector('.swiper'); 

      new Swiper(el, {
        slidesPerView: 1.75,
        spaceBetween: 10,

        breakpoints: {
          550: { slidesPerView: 2.15},
          750: { slidesPerView: 3.15},
          1000: { slidesPerView: 4.15, spaceBetween: 15 },
          1200: { slidesPerView: 5 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-you-might-like"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-you-might-like').forEach(function(section) {

      const set = section.querySelector('.product-set');
      if (!set) return;

      new Swiper(set.querySelector('.swiper'), {
        slidesPerView: 1.35,
        spaceBetween: 10,
        breakpoints: {
          600:  { slidesPerView: 2.15 },
          800:  { slidesPerView: 3.15 },
          1000: { slidesPerView: 4.15 },
          1200: { slidesPerView: 5, spaceBetween: 15 },
        },
      });

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-you-might-like',
                  },
                },
              }));

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();

              if (window.Rebuy?.SmartCart) {
                window.Rebuy.SmartCart.refresh();
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();
})();
